module.exports = __webpack_public_path__ + "static/9-f771eacf56b357820c46c15413bdc1b5.jpg";